import { paths } from '../paths';
import { lazyLoadLayout, lazyLoadPage } from '../utils';

export const settingsRoutes = [
  {
    path: paths.SETTINGS,
    element: lazyLoadPage('/settings', { path: '(dashboard)' }),
    state: {
      pageKey: 'settings',
      metadata: {
        title: 'Settings'
      },
      shoppingCart: {
        enabled: false
      }
    }
  },
  {
    path: paths.SETTINGS_BRANDING,
    element: lazyLoadPage('/settings/branding', { path: '(dashboard)' }),
    state: {
      pageKey: 'branding',
      metadata: {
        title: 'Branding'
      }
    }
  },
  {
    path: paths.SETTINGS_ACCOUNT,
    element: lazyLoadPage('/settings/account', { path: '(dashboard)' }),
    state: {
      pageKey: 'account',
      metadata: {
        title: 'Account'
      },
      shoppingCart: {
        enabled: false
      }
    }
  },
  {
    path: paths.SETTINGS_PAYMENT_METHODS,
    element: lazyLoadPage('/settings/payment-methods', { path: '(dashboard)' }),
    state: {
      pageKey: 'payment-methods',
      metadata: {
        title: 'Payment Methods'
      }
    }
  },
  {
    path: paths.SETTINGS_USERS,
    element: lazyLoadPage('/settings/users', { path: '(dashboard)' }),
    state: {
      pageKey: 'users',
      metadata: {
        title: 'Users'
      }
    }
  },
  {
    path: paths.SETTINGS_USERS_DETAIL(),
    element: lazyLoadLayout('/settings/users/[userId]', { path: '(dashboard)' }),
    children: [
      {
        index: true,
        element: lazyLoadPage('/settings/users/[userId]', { path: '(dashboard)' }),
        state: {
          pageKey: 'user-detail',
          metadata: {
            title: 'User detail'
          }
        }
      }
    ]
  }
];
